import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import SyncDataImage from './SyncDataImage'

const copy = {
  heading: `Sync data from your warehouse to all your destinations, instantly`,
  descriptions: [
    `Eliminate the need for manual CSV handling and custom Python data pipelines.`,
    `Seamlessly integrate customer profiles and crucial data from your warehouse into all your key business tools for advertising, marketing, sales, and more, automating customer engagement and personalizing experiences.`,
  ],
}

export const SyncData = () => {
  return (
    <StyledSectionBase variant="2Col">
      <Section.Copy alignSelf="center">
        <StyledCopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          {copy.descriptions.map((description, key) => (
            <CopyText.Description key={key} tag="p">
              {description}
            </CopyText.Description>
          ))}
        </StyledCopyTextBase>
      </Section.Copy>
      <StyledSectionContents>
        <SyncDataImage alt={`Illustration: ${copy.heading}`} />
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${({ theme }) => theme.breakpoints.down(`lg`)} {
    overflow-x: initial;
  }
`

const StyledSectionContents = styled(Section.Contents)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    align-content: center;
    display: grid;
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default SyncData
